export const HealthCheck = {
  //画面項目
  Common: {
    HealthCheckDate: '受診日',
    HealthCheckValue: '測定値',
  },
  Health: {
    HealthClass: '健診種別',
    MedicalCheckup: '健診',
    MedicalInstitution: '実施医療機関',
  },
  PreviousResidenceSymptoms: {
    PreviousResidenceSymptoms: '既住歴・症状',
    WorkMedicalHistory: '業務・既住歴',
    CurrentSubjectiveSymptoms: '自覚症状',
  },
  ComprehensiveJudgment: {
    ComprehensiveJudgment: '総合判定',
    ComprehensiveView: '総合所見',
    HealthGuidanceLevel: '保健指導レベル',
  },
  PhysicalExamination: {
    PhysicalExamination: '身体計測',
    Height: '身長',
    HeightUnit: 'cm',
    Weight: '体重',
    WeightUnit: 'kg',
    StandardWeight: '標準体重',
    BMI: 'BMI',
    BMIUnit: 'kg/m²',
    DegreeOfObesity: '肥満度',
    AbdominalCircumference: '腹囲',
    AbdominalCircumferenceUnit: 'cm',
  },
  Eyesight: {
    Eyesight: '視力',
    RightEyesightWithoutCorrection: '視力右裸眼',
    RightEyesightWithCorrection: '視力右矯正',
    LeftEyesightWithoutCorrection: '視力左裸眼',
    LeftEyesightWithCorrection: '視力左矯正',
    EyesightView: '視力所見',
  },
  Hearing: {
    Hearing: '聴力',
    RightHearing1000HZ: '聴力1000HZ右',
    RightHearing4000HZ: '聴力4000HZ右',
    LeftHearing1000HZ: '聴力1000HZ左',
    LeftHearing4000HZ: '聴力4000HZ左',
  },
  Chest: {
    Chest: '胸部',
    ChestView: '胸部所見',
    ChestXRayPulmonary: '胸部X線肺',
    ChestXRayHeart: '胸部X線心臓',
  },
  Stomach: {
    Stomach: '胃部',
    StomachView: '胃部所見',
  },
  BloodGlucoseUrinaryGlucose: {
    BloodGlucoseUrinaryGlucose: '血糖尿糖',
    FastingPlasmaGlucose: '空腹時血糖',
    PostprandialPlasmaGlucose: '食後(随時)血糖',
    PlasmaGlucoseUnit: 'mg/dL',
    HbA1c: 'HbA1c(NGSP)',
    HbA1cUnit: '%',
    UrinaryGlucose: '尿糖',
  },
  Urinalysis: {
    Urinalysis: '検尿',
    Proteinuria: '尿蛋白',
    OccultHematuria: '尿潜血',
    SedimentItem1: '沈渣項目1',
    item1: '項目1',
    SedimentItem2: '沈渣項目2',
    item2: '項目2',
    SedimentItem3: '沈渣項目3',
    item3: '項目3',
    SedimentItem4: '沈渣項目4',
    item4: '項目4',
    SedimentItem5: '沈渣項目5',
    item5: '項目5',
  },
  BloodPressure: {
    BloodPressure: '血圧',
    SystolicBloodPressure: '血圧(収縮期)',
    DiastolicBloodPressure: '血圧(拡張期)',
    BloodPressureUnit: 'mmHg',
  },
  Electrocardiograph: {
    Electrocardiograph: '心電図',
  },
  LiverFunction: {
    LiverFunction: '肝機能',
    AST: 'AST',
    ALT: 'ALT',
    ganmaGtp: 'y-GTP',
    LiverFunctionUnit: 'U/L',
  },
  Lipid: {
    Lipid: '脂質',
    TCho: 'T-CHO',
    HdlC: 'HDL-C',
    LdlC: 'LDL-C',
    Triglyceride: '中性脂肪',
    LipidUnit: 'mg/dL',
  },
  MetabolicFunction: {
    MetabolicFunction: '代謝機能',
    UricAcid: '尿酸',
    UricAcidUnit: 'mg/dL',
  },
  RenalFunction: {
    RenalFunction: '腎機能',
    Creatinine: 'クレアチニン',
    CreatinineUnit: 'mg/dL',
  },
  BloodGeneral: {
    BloodGeneral: '血液',
    RedBloodCellCount: '赤血球数',
    RedBloodCellCountUnit: '10⁴/μL',
    WhiteBloodCellCount: '白血球数',
    WhiteBloodCellCountUnit: '10²/μL',
    Hemoglobin: '血色色素',
    HemoglobinUnit: 'g/dL',
    PlateletCount: '血小板数',
    PlateletCountUnit: '10⁴/μL',
    Hematocrit: 'ヘマトクリット',
    HematocritUnit: '%',
  },
  StoolExamination: {
    StoolExamination: '検便',
    FecalOccultBlood1: '便潜血1',
    FecalOccultBlood2: '便潜血2',
  },
  Gynecology: {
    Gynecology: '婦人科',
    Breast: '乳房',
    BreastJudgement: '乳房判定',
    Uterine: '子宮',
    UterineClass: '子宮(クラス)',
    UterineJudgement: '子宮判定',
  },
  ScoreBenchmark: {
    ItemA: 'A',
    DescA: '異常なし',
    ItemB: 'B',
    DescB: '心配なし',
    ItemC: 'C',
    DescC: '要観察',
    ItemD: 'D',
    DescD: '要治療',
    ItemE: 'E',
    DescE: '要精密',
    ItemF: 'F',
    DescF: '治療中',
    Supplement: '※判定区分は所属の健保組合の基準で表示しています',
  },
  Transition: '推移',
};
